<mat-form-field #formFieldDatePicker [appearance]="appearance" (click)="picker.open()">
    <mat-label>{{'Choisissez une date' | translate}}</mat-label>
    <input #inputDatePicker matInput
        class="inputDate"
        [ngClass]="{'error-color': !isValidDate}"
        [ngModel]="ngModelDate"
        (ngModelChange)="ngModelDateChange.emit($event)"
        [value]="valueInput"
        [matDatepicker]="picker"
        [disabled]="true"
        (dateChange)="onDateChange($event)"
        [matDatepickerFilter]="datePickerFilter">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]=isDisabled></mat-datepicker>
</mat-form-field>
